import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
const momentObj = (moment as any);

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  year: number = 0;
  environment:any = environment;

  constructor() { }

  ngOnInit(): void {
    this.year = momentObj().year()
  }

}
